import React from "react";
import {MainMenuProvider} from "./context/MenuContext";
import ConsumerMenuContent from "./ConsumerMenuContent";
import ConsumerMenuDrawer from "./ConsumerMenuDrawer";

const MainMenu = () => {
  return (
    <MainMenuProvider>
      <ConsumerMenuDrawer>
        <ConsumerMenuContent />
      </ConsumerMenuDrawer>
    </MainMenuProvider>
  );
};

export default MainMenu;
